import router from '@/router'

export default {
  props: ['id'],
  computed: {
    doctor_key () {
      if (this.id && (this.id !== 'me')) {
        return this.id
      } else {
        return 'me'
      }
    },
    doctor_uri () {
      return this.$APP_CONFIG.api.admin.doctors_id(this.doctor_key)
    }
  },
  methods: {
    // step callback
    gotoPage (step) {
      router.push({
        path: this.next_uri(step),
        query: {
          action: this.$route.query.action,
          ref_clinic_id: this.$route.query.ref_clinic_id
        }
      })
    },
    next_uri (step) {
      if (this.$route.query.ref_clinic_id) {
        return `/doctor/step${step + 1}/${this.doctor_key}?ref_clinic_id=${this.$route.query.ref_clinic_id}`
      } else {
        return `/doctor/step${step + 1}/${this.doctor_key}`
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/doctor/steps/mixin.js